import * as actionTypes from '../action-types'

export const updateAgreementFilters = payload => {
  return {
    type: actionTypes.UPDATE_AGREEMENT_FILTERS,
    payload
  }
}

export const updatePurposeFilters = payload => {
  return {
    type: actionTypes.UPDATE_PURPOSE_FILTERS,
    payload
  }
}


// WEBPACK FOOTER //
// ./src/redux-store/actions/filter-actions.js